export const TOGGLE_FORM_IS_VALID =
  'src/DrivingLicenceForm/TOGGLE_FORM_IS_VALID'
export const SUBMIT_DRIVER_DETAILS_FORM =
  'src/DriverDetails/SUBMIT_DRIVER_DETAILS_FORM'
